import { useCallback } from 'react'
import { TSigner, useTownsClient, useTownsContext } from 'use-towns-client'
import { useShallow } from 'zustand/react/shallow'

import { publicPageLoginStore } from '../usePublicPageLoginFlow'

import { useJoinTown } from './useJoinTown'

type TClientSingleton = ReturnType<typeof useTownsClient>['clientSingleton']
type TSignerContext = ReturnType<typeof useTownsContext>['signerContext']

export function useStartJoinMeetsRequirements({ spaceId }: { spaceId: string | undefined }) {
    const joinTown = useJoinTown({ spaceId })

    const { setSpaceBeingJoined, disableJoinUi, setDisableJoinUi } = publicPageLoginStore(
        useShallow((s) => ({
            disableJoinUi: s.disableJoinUi,
            setDisableJoinUi: s.setDisableJoinUi,
            setSpaceBeingJoined: s.setSpaceBeingJoined,
        })),
    )

    return useCallback(
        async ({
            signer,
            clientSingleton,
            signerContext,
            source,
            analyticsData,
        }: {
            signer: TSigner
            clientSingleton: TClientSingleton
            signerContext: TSignerContext
            source: string
            analyticsData: {
                spaceName: string
            }
        }) => {
            if (!spaceId) {
                return
            }
            if (disableJoinUi) {
                return
            }

            if (clientSingleton && spaceId && signer) {
                setDisableJoinUi(true)
                setSpaceBeingJoined(spaceId)
                await joinTown({
                    signer,
                    clientSingleton,
                    signerContext,
                    source,
                    analyticsData,
                })

                setDisableJoinUi(false)
            }
        },
        [spaceId, disableJoinUi, setDisableJoinUi, setSpaceBeingJoined, joinTown],
    )
}
